import { mount, type MountInstance } from '../utils/components';
import Dialog from './dialog.vue';
import type { DialogOptions } from './dialog';

let dialogInstance: MountInstance | null = null;

/**
 * 显示对话框
 * @param options 对话框配置选项
 * @returns Promise，resolve 返回点击的按钮索引
 */
export function showDialog(options: DialogOptions): Promise<number> {
  return new Promise((resolve) => {
    // 如果已有对话框实例，先关闭
    if (dialogInstance) {
      hideDialog();
    }

    /**
     * 处理点击事件
     * @param index 按钮索引
     */
    const handleClick = (index: number) => {
      resolve(index);
      hideDialog();
    };

    /**
     * 处理 visible 更新
     * @param visible 是否可见
     */
    const handleUpdateVisible = (visible: boolean) => {
      if (!visible) {
        resolve(-1);
        hideDialog();
      }
    };

    // 挂载组件
    dialogInstance = mount(Dialog, {
      ...options,
      visible: true,
      onClick: handleClick,
      'onUpdate:visible': handleUpdateVisible,
    });
  });
}

/**
 * 隐藏当前对话框
 */
export function hideDialog(): void {
  if (dialogInstance) {
    dialogInstance.unmount();
    dialogInstance = null;
  }
}

